// import ThemeToggle from '@/components/common/theme-toggle';
import UserAvatar from '@/components/general/UserAvatar';
import { useTranslation } from 'react-i18next';
import SidebarToggle from './_components/SidebarToggle';
import SheetMenu from './SheetMenu';
interface NavbarProps {
    title: string
}

export default function Navbar({ title }: NavbarProps) {
    // hooks
    const { t } = useTranslation();

    return (
        <header className='sticky z-10 top-0 w-full bg-background/95 shadow backdrop-blur dark:shadow-secondary'>
            <div className='mx-4 sm:mx-8 flex h-16 items-center'>
                <div className='flex items-center space-x-4 lg:space-x-0'>
                    <SheetMenu />
                    <SidebarToggle />
                </div>
                <div className='flex flex-1 items-center space-x-2 justify-end'>
                    {/* <SelectLanguage /> */}
                    {/* <ThemeToggle /> */}
                    <UserAvatar />
                </div>
            </div>
        </header>
    );
}
